/**
 * Tarjeta. Es el contenedor de casi todo el maquetado: fondo `rgba(255,255,253,0.9)`, borde de
 * 1px tostado, radio 20–22px y sombra difusa.
 */
import type { CSSProperties, ReactNode } from 'react';
import styles from './Card.module.css';

type CardVariant = 'default' | 'sm' | 'xs' | 'table' | 'brand';

interface CardProps {
  children: ReactNode;
  variant?: CardVariant;
  className?: string;
  style?: CSSProperties;
}

const VARIANT_CLASS: Record<CardVariant, string> = {
  default: '',
  sm: styles.sm!,
  xs: styles.xs!,
  table: styles.table!,
  brand: styles.brand!,
};

export function Card({ children, variant = 'default', className, style }: CardProps) {
  const classes = [styles.card, VARIANT_CLASS[variant], className].filter(Boolean).join(' ');
  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
}

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  /** Contenido a la derecha del título: leyendas de gráfico, acciones… */
  aside?: ReactNode;
  size?: 'default' | 'sm';
  className?: string;
}

export function CardHeader({ title, subtitle, aside, size = 'default', className }: CardHeaderProps) {
  return (
    <div className={[styles.header, className].filter(Boolean).join(' ')}>
      <div>
        <div className={size === 'sm' ? styles.titleSm : styles.title}>{title}</div>
        {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
      </div>
      {aside}
    </div>
  );
}

export function CardSectionLabel({ children }: { children: ReactNode }) {
  return <div className={styles.sectionLabel}>{children}</div>;
}

export function CardDivider({ style }: { style?: CSSProperties }) {
  return <hr className={styles.divider} style={style} />;
}
